var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdvanced5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 515,
    height: 290,
    viewBox: "0 0 515 290",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1511_25185)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 515,
    height: 290,
    fill: "#FFC900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9317 93.0386C71.1054 91.6484 80.7732 89.2389 87.3159 85.2675C97.1202 79.32 100.967 69.9477 101.857 63.0748C105.422 35.6102 70.1066 33.4663 28.0453 35.8875C-5.70214 37.8283 -25.1859 35.0557 -39.7266 40.8821C-52.5389 46.0134 -55.8707 55.8464 -56.4637 65.5701C-56.9475 73.5053 -53.089 85.6345 -43.5695 88.0401C-27.8116 92.0233 3.42332 94.6983 27.7722 94.6983C34.3851 94.6983 40.9824 94.546 47.3262 94.1672C47.7943 113.169 53.8611 137.522 71.6555 146.066C71.8857 146.175 72.1003 145.879 71.9247 145.691C55.3397 127.954 59.1709 102.044 59.9317 93.0386Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8566 177.861L13.2033 169.832C13.0901 169.797 13.1135 169.637 13.2267 169.629L44.0519 168.489C44.5279 166.494 44.8829 164.451 45.1209 162.37L62.4862 157.555C64.4876 156.957 65.5098 154.841 65.5098 152.931C65.5098 152.923 65.5098 152.916 65.5098 152.908C65.3888 150.733 63.8322 148.952 61.4367 148.925L44.8478 148.522C41.0712 123.877 19.9957 105.012 -5.4378 105.012C-33.5437 105.012 -56.3281 128.048 -56.3281 156.465C-56.3281 184.883 -33.5437 207.919 -5.4378 207.919C15.115 207.915 32.8236 195.598 40.8566 177.861Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1899 152.556C17.6053 152.556 19.5634 150.577 19.5634 148.136C19.5634 145.694 17.6053 143.715 15.1899 143.715C12.7745 143.715 10.8164 145.694 10.8164 148.136C10.8164 150.577 12.7745 152.556 15.1899 152.556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3965 113.009C96.4593 83.1233 122.615 60.6455 153.966 60.6455C189.805 60.6455 218.855 90.0197 218.855 126.251C218.855 162.483 189.805 191.857 153.966 191.857C129.442 191.857 108.097 178.103 97.064 157.808C99.1942 158.07 101.445 158.082 103.755 157.82C112.923 156.773 120.223 151.658 122.236 145.507H91.9181C90.8296 141.918 90.0376 138.193 89.5733 134.37C79.3984 137.146 69.8281 130.227 69.8281 124.342C69.8242 117.504 76.8312 113.708 90.3965 113.009C94.0365 112.822 99.3269 112.814 102.44 112.825Z",
    fill: "#FF90E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3965 113.009C96.4593 83.1233 122.615 60.6455 153.966 60.6455C189.805 60.6455 218.855 90.0197 218.855 126.251C218.855 162.483 189.805 191.857 153.966 191.857C129.442 191.857 108.097 178.103 97.064 157.808C99.1942 158.07 101.445 158.082 103.755 157.82C112.923 156.773 120.223 151.658 122.236 145.507H91.9181C90.8296 141.918 90.0376 138.193 89.5733 134.37C79.3984 137.146 69.8281 130.227 69.8281 124.342C69.8242 117.504 76.8312 113.708 90.3965 113.009ZM90.3965 113.009C94.0365 112.822 99.3269 112.814 102.44 112.825",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.059 123.792C137.474 123.792 139.433 121.813 139.433 119.372C139.433 116.93 137.474 114.951 135.059 114.951C132.644 114.951 130.686 116.93 130.686 119.372C130.686 121.813 132.644 123.792 135.059 123.792Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8374 203.113C58.761 203.773 45.9877 205.151 35.922 207.799C20.4645 211.864 13.2773 224.105 13.2773 238.188C13.2773 252.27 17.6752 262.534 35.922 270.903C43.2099 274.246 59.7559 274.473 72.8374 274.398C86.8006 274.32 108.245 275.486 127.141 274.398C187.895 270.903 197.551 255.488 197.551 238.188C198.358 231.975 192.723 220.082 182.262 213.645C171.801 207.207 164.357 207.174 148.318 205.776C131.296 204.288 114.239 202.585 98.817 202.585C92.9766 202.585 87.2102 202.644 81.5922 202.792C78.1433 186.203 66.5366 174.363 51.2936 177.257C72.4823 185.766 72.8374 203.113 72.8374 203.113Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.33 215.648C296.589 217.667 291.907 221.868 282.271 221.888C274.878 233.474 261.999 241.144 247.349 241.144C224.413 241.144 205.822 222.345 205.822 199.156C205.822 175.972 224.413 157.169 247.349 157.169C270.286 157.169 288.876 175.968 288.876 199.156C288.876 200.836 288.778 202.495 288.587 204.124C299 207.291 298.357 212.848 297.33 215.648Z",
    fill: "#90A8ED",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.078 219.439C273.665 221.22 278.374 221.896 282.272 221.888Z",
    fill: "#90A8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.078 219.439C273.665 221.22 278.374 221.896 282.272 221.888",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.592 204.124C285.174 203.085 280.559 202.3 274.375 201.956Z",
    fill: "#90A8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.592 204.124C285.174 203.085 280.559 202.3 274.375 201.956",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.06 228.077C268.665 233.251 250.597 231.404 248.725 223.879L268.06 228.077Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.458 209.22C256.705 209.22 258.527 207.377 258.527 205.104C258.527 202.831 256.705 200.988 254.458 200.988C252.211 200.988 250.389 202.831 250.389 205.104C250.389 207.377 252.211 209.22 254.458 209.22Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.257 100.545C288.834 97.128 300.885 82.7963 304.915 65.9341C309.308 47.5606 294.382 31.0107 257.014 31.8503C230.628 32.4439 211.066 47.3887 211.066 66.5589C211.066 85.5181 229.048 101.861 256.12 101.291C258.36 140.74 272.576 148.656 289.911 138.323C274.695 138.053 269.057 132.508 266.728 120.094C265.277 110.562 265.257 100.545 265.257 100.545Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.733 365.453C306.742 360.669 323.615 340.604 329.257 316.995C335.408 291.271 314.509 268.1 262.191 269.275C225.249 270.106 197.861 291.03 197.861 317.87C197.861 344.415 223.037 367.296 260.94 366.498C264.076 421.73 283.98 432.812 308.249 418.345C286.946 417.968 279.053 410.204 275.792 392.823C273.76 379.477 273.733 365.453 273.733 365.453Z",
    fill: "#FF7051",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.229 103.946C305.932 103.161 299.26 102.275 296.053 107.031C293.67 110.561 294.263 117.673 305.678 118.805C306.049 122.464 306.771 126.018 307.804 129.435L335.61 130.192C336.277 130.212 336.55 131.071 336.012 131.477L316.271 146.395C326.367 160.18 342.562 169.126 360.821 169.169C390.991 169.239 415.57 145.227 416.487 114.74C417.45 82.6868 391.841 56.4367 360.267 56.8194C332.957 57.1514 310.653 77.1299 306.197 103.333",
    fill: "#FFC900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.229 103.946C305.932 103.161 299.26 102.275 296.053 107.031C293.67 110.561 294.263 117.673 305.678 118.805C306.049 122.464 306.771 126.018 307.804 129.435L335.61 130.192C336.277 130.212 336.55 131.071 336.012 131.477L316.271 146.395C326.367 160.18 342.562 169.126 360.821 169.169C390.991 169.239 415.57 145.227 416.487 114.74C417.45 82.6868 391.841 56.4367 360.267 56.8194C332.957 57.1514 310.653 77.1299 306.197 103.333",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.403 113.232C337.689 113.232 339.543 111.358 339.543 109.046C339.543 106.734 337.689 104.859 335.403 104.859C333.117 104.859 331.264 106.734 331.264 109.046C331.264 111.358 333.117 113.232 335.403 113.232Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.427 237.964C349.539 243.549 364.961 246.911 384.741 246.637C437.2 245.907 451.237 235.563 456.563 204.451C458.197 194.891 450.176 184.515 432.908 179.267C420.65 175.541 401.4 176.744 384.741 177.025C346.612 177.67 315.553 182.75 316.876 209.465C317.321 218.474 322.096 227.018 331.249 233.637C323.949 240.362 296.904 243.24 296.904 243.24C296.904 243.24 320.387 252.331 338.427 237.964Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.559 158.232C485.182 161.609 484.074 165.128 483.266 168.76L496.574 177.605L481.713 181.397C481.698 181.982 481.69 182.572 481.69 183.166C481.69 211.196 499.133 235.111 523.642 244.417V121.91C511.376 126.569 500.877 134.887 493.453 145.548C482.65 140.893 480.309 140.893 478.362 141.514C476.946 141.963 473.321 144.79 474.652 149.453C475.986 154.116 486.559 158.232 486.559 158.232Z",
    fill: "#98282A",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.122 163.721C508.414 163.721 510.273 161.842 510.273 159.523C510.273 157.205 508.414 155.325 506.122 155.325C503.829 155.325 501.971 157.205 501.971 159.523C501.971 161.842 503.829 163.721 506.122 163.721Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.946 114.274C465.288 114.442 466.626 114.52 467.952 114.509C493.238 114.259 510.802 96.6192 509.803 77.4686C509.522 72.1264 508.09 67.413 506.288 63.3946C500.623 50.7734 490.109 43.2678 467.956 40.7021C456.993 39.4329 445.812 38.402 437.471 46.0169C429.508 53.2843 424.604 63.6836 425.583 76.5587C426.71 91.3942 440.775 106.925 456.283 112.427C448.707 134.253 445.636 152.767 462.112 161.487C449.6 143.781 463.946 114.274 463.946 114.274Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 474.166,
    cy: 316.66,
    r: 69.0078,
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 376.837,
    cy: -24.7561,
    r: 58.8995,
    fill: "#90A8ED",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.547,
    cy: -55.9258,
    r: 77.0547,
    fill: "#98282A",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.82812,
    cy: -51.0631,
    r: 72.2266,
    fill: "#FF7051",
    stroke: "black",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1511_25185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 515,
    height: 290,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvanced5);
export default __webpack_public_path__ + "static/media/advanced5.419207833c952f8ddd2e7acbb6ebb01b.svg";
export { ForwardRef as ReactComponent };